import React from 'react';
import styled, { css } from 'styled-components';

import MQ, { PREFIX, SM_MAX } from '@rover/kibble/styles/MediaQuery';
import Image from '@rover/react-lib/src/components/images/Image';

const MQ_MOBILE = `${PREFIX}(max-width:${414}px)`;
const MQ_TABLET = `${PREFIX}(min-width:${415}px) and (max-width:${SM_MAX}px)`;
export interface Coordinates {
  width: string;
  height: string;
}

const StyledImageStars = styled.div<{
  starSrc: string;
  defaultCoordinates: Coordinates;
  tabletCoordinates: Coordinates;
  mobileCoordinates: Coordinates;
  right: boolean;
}>`
  position: absolute;
  background-image: url(${(props) => props.starSrc});
  background-position: center center;
  z-index: 10;

  ${MQ.MD_UP.toString()} {
    width: ${(props) => props.defaultCoordinates.width};
    height: ${(props) => props.defaultCoordinates.height};
    bottom: -64px;

    ${(props) =>
      props.right
        ? css`
            right: -64px;
          `
        : css`
            left: -64px;
          `};
  }

  ${MQ_MOBILE} {
    width: ${(props) => props.mobileCoordinates.width};
    height: ${(props) => props.mobileCoordinates.height};
    bottom: 0;

    ${(props) =>
      props.right
        ? css`
            right: 0;
          `
        : css`
            left: 0;
          `};
  }

  ${MQ_TABLET} {
    width: ${(props) => props.tabletCoordinates.width};
    height: ${(props) => props.tabletCoordinates.height};
    bottom: 0;

    ${(props) =>
      props.right
        ? css`
            right: 0;
          `
        : css`
            left: 0;
          `};
  }

  background-size: cover;
  background-position: center;
`;
const CaptionedImageWrap = styled.div`
  position: relative;
`;
const StyledImageDesktop = styled(Image)`
  display: none;
  border-radius: ${({ theme }) => theme.radii.primary};
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;

  ${MQ.MD_UP.toString()} {
    display: block;
    width: 100%;
  }
`;
const StyledImageMobile = styled(Image)`
  display: none;
  border-radius: ${({ theme }) => theme.radii.primary};
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;

  ${MQ_MOBILE.toString()} {
    display: block;
  }
`;
const StyledImageTablet = styled(Image)`
  display: none;
  border-radius: ${({ theme }) => theme.radii.primary};
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;

  ${MQ_TABLET.toString()} {
    display: block;
  }
`;
export type Props = {
  defaultImageSrc?: string;
  tabletImageSrc?: string;
  mobileImageSrc?: string;
  additionalImage?: string;
  defaultCoordinates?: Coordinates;
  tabletCoordinates?: Coordinates;
  mobileCoordinates?: Coordinates;
  right?: boolean;
};

const MultiImage = ({
  defaultImageSrc = '',
  tabletImageSrc = '',
  mobileImageSrc = '',
  additionalImage = '',
  defaultCoordinates = { height: '', width: '' },
  tabletCoordinates = { height: '', width: '' },
  mobileCoordinates = { height: '', width: '' },
  right = false,
}: Props): JSX.Element => (
  <CaptionedImageWrap data-testid="multi-image">
    <StyledImageStars
      starSrc={additionalImage}
      defaultCoordinates={defaultCoordinates}
      tabletCoordinates={tabletCoordinates}
      mobileCoordinates={mobileCoordinates}
      right={right}
    />

    <StyledImageDesktop src={defaultImageSrc} lazy={false} alt="guarantee-sitter-desktop" />
    <StyledImageTablet src={tabletImageSrc} lazy={false} alt="guarantee-sitter-tablet" />
    <StyledImageMobile src={mobileImageSrc} lazy={false} alt="guarantee-sitter-mobile" />
  </CaptionedImageWrap>
);

export default MultiImage;
